import { assocPath, mergeRight } from 'ramda';

export const mergeWithTopLevelProp = (propName, freshData, state) =>
  // We can update individual fields in `propName` in each freshData payload by using `mergeWith`
  assocPath([propName], mergeRight(state[propName], freshData), state);
